import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { PosTypeEntity } from "../../types/PosTypeEntity";
import { PosTypeDtoToEntity } from "../mappers/PosTypeDtoToEntity";
import { PosTypeEntityToDto } from "../mappers/PosTypeEntityToDto";

const PosTypeApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        PosTypeLoad: builder.query<PosTypeEntity, FormQuery>({
            providesTags: [ResourceName.POS_TYPES],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.POS_TYPES}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return PosTypeDtoToEntity(response);
            },
        }),
        PosTypeSave: builder.mutation<PosTypeEntity, FormMutation<PosTypeEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.POS_TYPES}`;
                const method = "POST";

                const body = PosTypeEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.POS_TYPES],
        }),
        PosTypeUpdate: builder.mutation<PosTypeEntity, FormMutation<PosTypeEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.POS_TYPES}/${mutation.data.id}`;
                const method = "PUT";

                const body = PosTypeEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.POS_TYPES],
        }),
    }),
});

export const { usePosTypeLoadQuery, usePosTypeSaveMutation, usePosTypeUpdateMutation } = PosTypeApi;
